import { routes } from 'commons/constants/routes'
import { Link } from 'ui/components'
import { DateTime } from 'ui/components/DateTime'
import { TableColumn } from 'ui/components/Table'
import { AlertsHighRiskReview } from '~bank-alerts/types'

import * as SC from './styles'

export const columns: TableColumn<AlertsHighRiskReview>[] = [
  {
    title: 'Period',
    align: 'left',
    sortable: false,
    render: ({ period, id }) => (
      <Link to={routes.bank.hrr.details} params={{ id: id.toString() }}>
        {period}
      </Link>
    )
  },
  {
    title: 'Status',
    align: 'center',
    render: ({ status, highlightStatus }) =>
      highlightStatus ? <SC.HighlightStatus>{status}</SC.HighlightStatus> : <>{status}</>
  },
  {
    title: 'Last Modified Date',
    sortable: false,
    align: 'left',
    render: ({ lastModifiedDate }) => <DateTime date={lastModifiedDate} withTime />
  }
]
